module.exports = __webpack_public_path__ + "img/LB.ca800d9b.png";